<template>
    <button-secondary @click="open">
        <template slot="icon"><i class="fa fa-upload"></i></template>
        User hochladen
        <portal to="modal" v-if="showModal">
            <modal :show="showModal" @close="confirmAbort">
                <template v-slot:header>User einladen</template>

                <div v-if="action === 'upload'">

                    <div>
                        <input ref="file" class="mb-8" type="file" @change="handleFileUpload()"/>
                    </div>

                    <p>Hochladen einer Nutzerdatei</p>

                    <p class="mt-2 text-sm text-gray-500">
                        In der ersten Zeile der Hochgeladen Datei muss das Feld "email" vorhanden sein.<br>
                        Es werden die Felder "Name", "Vorname", "Schreibtisch", "Raum", "Priorität", "Usergruppe" "Personalnummer" und "may_book_multiple_desks" erkannt.
                    </p>

                    <loading v-show="loading"></loading>

                </div>

                <div v-if="action === 'analyze'">

                    <p class="mb-4">
                        <button-link @click="action='upload'">
                            <i class="fa fa-chevron-left mr-2"></i> Neue Datei Hochladen
                        </button-link>
                    </p>

                    {{ users.length }} Nutzer erkannt.

                    <tailwind-table :header="['E-Mail', 'Name', 'Informationen']" v-show="users.length > 0">
                        <tr v-for="user in users" :key="user.email">
                            <td>{{ user.email }}</td>
                            <td>{{ user.first_name }} {{ user.name }}</td>
                            <td>{{ intel(user) }}</td>
                        </tr>
                    </tailwind-table>

                    <p v-show="users.length === 0">Keine Nutzer erkannt. Ist die Datei richtig formatiert?</p>


                    <div class="flex justify-end mt-8" v-show="users.length > 0 && !saving">
                        <button-secondary class="mr-2" @click="uploadUsers">
                            Nutzer einlesen
                        </button-secondary>
                        <button-primary @click="uploadUsers(true)">
                            Nutzer einlesen &amp; einladen
                        </button-primary>
                    </div>

                    <loading v-show="saving"></loading>

                </div>

            </modal>
        </portal>
    </button-secondary>
</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import Loading from "../UI/Loading.vue";
import InputText from "../UI/InputText.vue";
import Modal from "../Modal.vue";
import TailwindTable from "../UI/TailwindTable.vue";
import ButtonLink from "../UI/ButtonLink.vue";

export default {
    name: "UserInviteUpload",

    inject: ['group'],

    components: {
        ButtonLink,
        ButtonPrimary,
        TailwindTable,
        Modal,
        InputText,
        Loading,
        ButtonSecondary
    },

    data: () => ({
        action: 'upload',
        loading: false,
        saving: false,
        users: [],
        showModal: false,
    }),

    methods: {
        open() {
            this.showModal = true;
            this.action = 'upload';
        },
        confirmAbort() {
            if (!confirm('Wirklich abbrechen?')) {
                return;
            }
            this.showModal = false;
        },
        handleFileUpload() {
            let file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('file', file);
            if (this.action === 'upload') {
                formData.append('analyze', 'true');
            }
            this.loading = true;
            this.$http
                .post(`/admin/user_invitees`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.loading = false;
                    this.action = 'analyze';
                    this.users = response.data.data;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        uploadUsers(withMail = false) {
            this.saving = true;
            this.$http
                .post(`/admin/user_invitees`, {
                    users: this.users,
                    mail: withMail,
                })
                .then((response) => {
                    this.saving = false;
                    this.action = 'done';
                    this.users = response.data.data;
                    this.showModal = false;
                    this.$emit('reload');
                    this.$root.$emit('alert', 'Gespeichert.');
                })
                .catch(error => {
                    this.saving = false;
                    this.$root.$emit('error', error);
                });
        },
        intel(user) {
            return Object.keys(user)
                .filter(key => {
                    return !['name', 'first_name', 'email'].includes(key);
                })
                .filter(key => {
                    return user[key];
                })
                .map(key => {
                    return this.translate(key) + ': ' + user[key];
                })
                .join(', ');
        },
        translate(key) {
            if (key === 'user_group') {
                return 'Benutzergruppe';
            }
            if (key === 'user_groups') {
                return 'Benutzergruppen';
            }
            return key;
        }
    }
}
</script>

<style scoped>

</style>
